module.exports = __webpack_public_path__ + "static/media/riri.bfa931ba.jpg";